import useUpdatePoolTaskSubmissions from '../../../../../hooks/useUpdatePoolTaskSubmissions'
import SharedImageVerificationTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/ImageVerification'
import TaskAllocationAmount from '../../../../../shared_components/Missions/TaskAllocationAmount'

export default function ImageVerificationTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedImageVerificationTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
